/******************************************************
 *                  Resize directive
 *
 * This directice resizes an element to fit into space left by other elements
 * on same column.
 * TODO : make me dynamic (hard coded elements IDs)
 ********************************************************/

"use strict";

angular.module("app")
	.directive("resizeIndicators", ["$timeout", function ($timeout) {

		return function () {
			$timeout(function () {
				$(".to-be-resized").height($("#analyze-container").outerHeight(true) - 300);
			});
		};
	}]);